import { FC } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import { GlobalModalTypeEnum } from 'enums/entity';

import { translate } from 'utils/translate';
import useScreen from 'hooks/useScreen';

import SocialBox from './SocialBox';

type Props = {
  logo?: string;
  bgColor?: string;
  buttonsColor?: string;
  openGlobalModal: (value: GlobalModalTypeEnum) => void;
};

const Header: FC<Props> = ({ logo, openGlobalModal, buttonsColor, bgColor }) => {
  const { isMobile } = useScreen();

  return (
    <AppBar
      sx={{ bgcolor: bgColor || 'custom.common.black', color: 'custom.common.white', borderRadius: 0 }}
      position="static"
    >
      <Container>
        <Stack width="100%" flexDirection="row" justifyContent="space-between" alignItems="center" flexWrap="wrap">
          <img
            src={logo || '/assets/images/light-logo.svg'}
            width={isMobile ? 150 : 200}
            height={60}
            style={{ objectFit: 'contain' }}
          />
          <Box display="flex" alignItems="center">
            {!isMobile && (
              <Stack direction="row" alignItems="center" sx={{ mr: 2 }}>
                <SocialBox />
              </Stack>
            )}
            <Box display="flex">
              <Button
                size="small"
                variant="contained"
                sx={{ mr: 1, background: buttonsColor }}
                onClick={(): void => openGlobalModal(GlobalModalTypeEnum.SIGN_IN)}
              >
                {translate('Login')}
              </Button>
              <Button
                sx={{ background: buttonsColor }}
                size="small"
                variant="contained"
                color="primary"
                onClick={(): void => openGlobalModal(GlobalModalTypeEnum.SIGN_UP)}
              >
                {translate('Sign up')}
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppBar>
  );
};

export default Header;
